const OpenID = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="6.36168" fill="black" />
    <g clipPath="url(#clip0_927_8880)">
      <path
        d="M12.0837 17.125L11.3993 16.4406C11.0695 16.1134 10.8079 15.7239 10.6296 15.2949C10.4513 14.8658 10.3599 14.4057 10.3607 13.9411C10.3597 13.4765 10.4506 13.0162 10.6283 12.587C10.806 12.1577 11.067 11.7678 11.3961 11.4399C11.724 11.1108 12.1139 10.8498 12.5431 10.6721C12.9724 10.4944 13.4326 10.4035 13.8973 10.4046C14.3613 10.4039 14.8209 10.4951 15.2496 10.6727C15.6783 10.8504 16.0677 11.1112 16.3952 11.4399L17.078 12.1244L19.5569 9.64707L18.8725 8.96263C18.2203 8.30657 17.4445 7.78632 16.59 7.43197C15.7355 7.07762 14.8192 6.8962 13.8941 6.89821C12.969 6.8962 12.0527 7.07762 11.1982 7.43197C10.3436 7.78632 9.56784 8.30657 8.91564 8.96263C8.25943 9.61472 7.73908 10.3905 7.38472 11.245C7.03036 12.0996 6.84903 13.016 6.85122 13.9411C6.84881 14.866 7.03003 15.7822 7.38441 16.6365C7.73879 17.4908 8.25927 18.2663 8.91564 18.9179L9.60008 19.6023L12.0837 17.125Z"
        fill="#FF4F40"
      />
      <path
        d="M22.9982 13.0818L22.3138 12.3989L19.8365 14.8762L20.5209 15.5607C20.8505 15.888 21.1117 16.2775 21.2894 16.7065C21.4672 17.1356 21.5579 17.5958 21.5563 18.0602C21.5582 18.5246 21.4679 18.9848 21.2907 19.4141C21.1135 19.8435 20.853 20.2334 20.5241 20.5613C19.8603 21.2232 18.9612 21.5948 18.0238 21.5948C17.0864 21.5948 16.1873 21.2232 15.5234 20.5613L14.839 19.8769L12.3617 22.3542L13.0461 23.0386C13.699 23.6939 14.4749 24.2135 15.3293 24.5678C16.1836 24.9221 17.0996 25.104 18.0246 25.1031C18.9492 25.1039 19.865 24.9219 20.7191 24.5677C21.5732 24.2134 22.3488 23.6937 23.0014 23.0386C23.658 22.3868 24.1786 21.6111 24.5329 20.7565C24.8873 19.9019 25.0685 18.9854 25.0658 18.0602C25.068 17.1348 24.8864 16.2182 24.5315 15.3636C24.1765 14.5089 23.6554 13.7333 22.9982 13.0818Z"
        fill="#3EC6EB"
      />
      <path
        d="M17.0865 12.1228L12.0885 17.1208L14.8407 19.8731L19.8387 14.8751L17.0865 12.1228Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_927_8880">
        <rect
          width="18.2003"
          height="18.1971"
          fill="white"
          transform="translate(6.86084 6.90137)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default OpenID;
